import { passwordScore } from '@smartapply/shared';

interface PasswordStrengthProps {
  value: string;
}

/**
 * Indicador visual de força de senha — barra segmentada com 4 stages.
 * Score real é validado no schema; este componente é só feedback UX.
 */
export function PasswordStrength({ value }: PasswordStrengthProps) {
  const { score, label } = passwordScore(value);

  const stages = [1, 2, 3, 4] as const;
  const colors = {
    1: 'var(--accent-crimson)',
    2: 'var(--accent-saffron)',
    3: 'var(--accent-saffron)',
    4: 'var(--accent-forest)',
  } as const;

  return (
    <div className="mt-2">
      <div className="flex gap-1">
        {stages.map((s) => (
          <div
            key={s}
            className="h-1 flex-1 rounded-sm transition-colors"
            style={{
              backgroundColor:
                s <= score ? (colors[s as keyof typeof colors] ?? 'var(--ink-muted)') : 'var(--bg-paper-recessed)',
            }}
          />
        ))}
      </div>
      <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.18em] text-[var(--ink-tertiary)]">
        força:{' '}
        <span className="text-[var(--ink-secondary)]">{label}</span>
      </p>
    </div>
  );
}
